<div id="managePopUp" *ngIf="!isSnagPopup">
  <div class="modal-header">
    <h4> <span class="box_icon"></span> {{title}} </h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClose(true)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body"> {{message}} </div>
  <div class="modal-footer justify-content-end">
    <div class="button-row" *ngIf ="modalFootershow">
      <button class="btn primary_btn ok-btn" (click)="onClose()">{{btnOkText}}</button>
    </div>
  </div>
</div>
<div *ngIf="isSnagPopup">
  <div class="modal-header">
    <h4> <span class="box_icon"></span> {{title}} </h4>
  </div>
  <div class="modal-body"> {{message}} </div>
  <div class="modal-footer justify-content-end">
    <div class="button-row">
      <button class="btn primary_btn ok-btn" (click)="navigateToDashboard()">{{btnOkText}}</button>
    </div>
  </div>
</div>
